/*

Client List

*/

import React, { useEffect, useState } from "react";
import InputTextSimple from "../../../components/common/InputText/InputTextSimple";
import ClientIcon from ".//..//..//..//assets//images//icons//clients.svg";
// import DropDown from "./DropDown";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import Button from "../../../components/common/buttons/Button";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import useAuth from "../../../hooks/useAuth";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import { toast } from "react-toastify";

const Ugyfelek = () => {
  const [calCount, setCalCount] = useState(125);
  const navigate = useNavigate();

  const handleRowClicked = (row) => {
    const sorszama = row["sorszama"];
    console.log(`Selected Row Data:\n${sorszama}`);
    // navigate(ROUTES.CAL_DATA_SHEET, {
    //   state: {
    //     sorszama: sorszama,
    //   },
    // });
  };
  const customStyles = {
    rows: {
      style: {
        minHeight: "40px",
        background: "#eee",
        marginTop: "0.625rem",
        marginBottom: "0.625rem",
        borderRadius: "1rem",
        border: 0,
        cursor: "pointer",
        boxShadow: "0px 4px 4px 0px rgba(16, 16, 16, 0.10)",
      },
    },

    headCells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
    cells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
  };

  const columns = [
    {
      name: "Név",
      selector: (row) => row.nev,
    },
    {
      name: "Ügyfélszám",
      selector: (row) => row.ugyfelszam,
    },
    {
      name: "Cím",
      selector: (row) => row.cim,
    },
    {
      name: "Telefonszám",
      selector: (row) => row.telefonszam,
      width: "10rem",
    },
  ];

  const data = [
    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },
    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },
    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },
    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },
    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },
    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },

    {
      nev: "Ügyfél neve",
      ugyfelszam: 1234567,
      cim: "1234 Budapest, Király utca 7. ",
      telefonszam: "+3630234567",
    },
  ];

  const [customerList, setCustomerList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { getAuth, clearAuth } = useAuth();
  const fetchData = () => {
    HttpHelper.GetRequest({
      route: API_ROUTES.CUSTOMER_LIST,
      token: getAuth()?.bearerToken,
      searchQuery: searchQuery,
    })
      .then((data) => {
        if (data.status == 200) {
          const customerList = data?.data?.customers;
          console.log(customerList);

          const newData = customerList.map((item) => ({
            nev: `${item.keresztnev} ${item.vezeteknev}`,
            ugyfelszam: item.ugyfelszam,
            cim: item.cim,
            telefonszam: item.telefonszam,
          }));

          setCustomerList(newData);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error("Unknown server error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        toast.error("Unknown server error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, [searchQuery]);

  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <div className=" mt-[3rem]  flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
          <Link to={ROUTES.ADMIN_HOME}>
            <i className="bg-[rgba(6,85,103,0.5)] h-[4.3rem] w-[4.3rem] rounded-full flex justify-center items-center">
              <img src={ClientIcon} alt="items icon" className="w-[2.5rem] " />
            </i>
          </Link>
          <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Ügyfelek</h2>
        </div>
        {/* Header Start */}
        <div className="mt-[3rem] flex flex-col lg:flex-row  justify-between gap-4 ">
          <div className="w-full md:w-1/4">
            <InputTextSimple
              placeholder={`Ügyfél keresése`}
              variant="bold"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </div>
          <div className="flex items-center gap-[1.125rem] ">
            {/* <DropDown /> */}
            <Link to={ROUTES.CAL_MANAGE_CUSTOMER_DATA}>
              <Button label={`Lista importálás`} />
            </Link>
          </div>
        </div>
        {/* Header End */}

        {/* Table Start */}
        <div className="mt-[3rem] w-full  ">
          <DataTable
            columns={columns}
            data={customerList}
            onRowClicked={handleRowClicked}
            customStyles={customStyles}
          />
        </div>
        {/* Table End */}
      </div>
    </>
  );
};

export default Ugyfelek;
